import script from "./CreateProjectInviteEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateProjectInviteEmail.vue?vue&type=script&setup=true&lang=js"

import "./CreateProjectInviteEmail.vue?vue&type=style&index=0&id=15f3d1ae&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15f3d1ae"]])

export default __exports__